import type { ReactNode, HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Поднимать карту при наведении (translateY -1px, без bounce) */
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const PAD: Record<NonNullable<CardProps['padding']>, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-5',
  lg: 'p-6',
};

export function Card({ children, interactive = false, padding = 'md', className, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'bg-ops-surface rounded-ops-card border border-ops-border shadow-ops-card',
        'transition duration-ops ease-ops',
        interactive && 'cursor-pointer hover:-translate-y-px hover:shadow-ops-card-hover',
        PAD[padding],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="text-ops-title font-semibold text-ops-text">{title}</h3>
        {subtitle && <p className="mt-0.5 text-ops-caption text-ops-text-tertiary">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
